
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.203 15.192c0 2.65 2.686 4.8 6 4.8h9.6c3.314 0 6-2.15 6-4.8 0-2.352-2.114-4.309-4.904-4.72a6.002 6.002 0 00-11.791 0c-2.791.412-4.905 2.368-4.905 4.72z","stroke":"#46D064","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.125 14.112l1.92 1.92 3.84-4.8","stroke":"#46D064","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    